import request from "@/axios";
/** 获取媒资来源(合作方)接口 */
export const getMediaSource = () => { 
  return request({
    url: `/lebo-vod/vod/partner/page`,
    method: "get",
    params: {
      current: 1,
      size: 9999,
      status: '1',

    }
  });
}
/** 分页查询推荐策略管理接口 */
export const getList = params => {
  return request({
    url: `/lebo-vod/vod/tactics/page`,
    method: "get",
    params
  });
};
/** 获取媒资选择列表的数据 */
export const getMediaList = params => {
  return request({
    url: `/lebo-vod/vod/media/page`,
    method: "get",
    params
  });
};
/** 新增推荐策略接口 */
export const add = data => {
  return request({
    url: `/lebo-vod/vod/tactics/save`,
    method: "post",
    data
  });
};
/** 获取策略详情的接口 */
export const getDetail = id => {
  return request({
    url: `/lebo-vod/vod/tactics/getById`,
    method: "get",
    params: {
      id
    }
  });
};
/** 修改推荐策略的接口 */
export const edit = data => {
  return request({
    url: `/lebo-vod/vod/tactics/update`,
    method: "post",
    data
  });
};
/** 删除推荐策略的接口 */
export const del = id => {
  return request({
    url: `/lebo-vod/vod/tactics/delById`,
    method: "get",
    params: {
      id
    }
  });
};
/** 媒资策略排序的接口 */
export const sort = data => {
  return request({
    url: `/lebo-vod/vod/tactics/resetMediaById`,
    method: "post",
    data
  });
};
/** 获取媒资信息的详情 */
export const getMediaDetail = id => {
  return request({
    url: `/lebo-vod/vod/tactics-media/detail/${id}`,
    method: "get",
  });
};
/** 获取媒资详情 */
export const getMediaInfo = id => {
  return request({
    url: `/lebo-vod/vod/media/getById`,
    method: "get",
    params: {
      id
    }
  });
};
